<template lang="pug">
.content-wrap.custom-font2
  .content-top
    .con
      .game-wrap
        .game-area
          // Field background — covers the full container
          img.field-bg(src='/new/img/events/june-2026/PNG/mock.png' alt='')
          // Title banner
          .layer.title-bar
            img(src='/new/img/events/june-2026/PNG/TITLE.png' alt='EpicWin Champions League')
          // Counter + info icon row
          .layer.hud-row
            .counter
              img.shoot-left-label(src='/new/img/events/june-2026/PNG/SHOOT-LEFT.png' alt='Shoot Left:')
              img#shoot-digit.digit-img(:src="`/new/img/events/june-2026/PNG/${tokenBalance}.png`")
            img#info-icon.info-icon(src='/new/img/events/june-2026/PNG/info.png' alt='Terms and Conditions' @click="toggleTnc")
          // T&C subtitle
          .layer.tc-bar
            img(src='/new/img/events/june-2026/PNG/T&-C.png' alt='Make Sure Balance Below RM1 To Shoot Ball, Or T&C Apply')
          // Goalkeeper
          //- img#goalkeeper.goalkeeper(v-if="ballKick == false" src='/new/img/events/june-2026/PNG/goalkeeper-A.png' alt='Goalkeeper')
          //- img#goalkeeper.goalkeeper(v-if="ballKick == true" :class="[{'dive-left': diveLeft == true}, {'dive-right': diveRight == true}]" :src=`'/new/img/events/june-2026/PNG/${gkStance}.png'` alt='Goalkeeper')
          img#goalkeeper.goalkeeper(:class="[{'dive-left': diveLeft == true}, {'dive-right': diveRight == true}]" :src='`/new/img/events/june-2026/PNG/${gkStance}.png`' alt='Goalkeeper')
          // Ball + directional controls
          .layer.ball-row
            button#left-btn.arrow-btn(aria-label='Move ball left' @click="toggleLeft" :disabled="startRender == true")
              img(src='/new/img/events/june-2026/PNG/left-button.png' alt='Left')
            img#ball.ball(:class="[{'nudge-left': toLeft == true}, {'nudge-right': toRight == true}]" :src='`/new/img/events/june-2026/PNG/${ballDir}.png`' alt='Ball')
            //- img#ball.ball(:class="[{'nudge-left': toLeft == true && ballKick == false}, {'nudge-right': toRight == true && ballKick == false}, {'fly-left': toLeft == true && ballKick == true}, {'fly-right' : toRight == true && ballKick == true}]" src='/new/img/events/june-2026/PNG/BALL.png' alt='Ball')
            button#right-btn.arrow-btn(aria-label='Move ball right' @click="toggleRight"  :disabled="startRender == true")
              img(src='/new/img/events/june-2026/PNG/right-button.png' alt='Right')
          // Shoot button
          .layer.shoot-bar
            button#shoot-btn.shoot-btn(v-if="isLoggedIn" aria-label='Shoot' @click="kickBall"  :disabled="startRender == true || tokenBalance == 0")
              img(src='/new/img/events/june-2026/PNG/SHOOT--BUTTON.png' alt='SHOOT!')
            button#shoot-btn.shoot-btn(v-if="!isLoggedIn" aria-label='Shoot' @click="$router.push('/login').catch(err => {})")
              img(src='/new/img/events/june-2026/PNG/SHOOT--BUTTON.png' alt='SHOOT!')
        // Terms & Conditions — sits below the field, outside game-area
        .terms-bar
          .terms-text(v-if="getLanguage=='en'")
            p
              strong TERMS AND CONDITIONS
            p
              strong TOKEN REWARDS BASED ON DAILY ACCUMULATED DEPOSIT
            p
              ul
                li DEPOSIT RM80: GET 1 TOKEN 
                li DEPOSIT RM150: GET 3 TOKENS 
                li DEPOSIT RM500: GET 8 TOKENS 
                li DEPOSIT RM1000: GET 15 TOKENS
            p
              strong REWARD DETAILS
            p
              ul
                li REWARD POOL RANGES FROM RM8 UP TO RM88 
                li MAX 15 TOKENS/DAY 
                li MAX 15 TOKENS STORED IN WALLET 
                li X10 TURNOVER REQUIRED BEFORE WITHDRAWAL 
                li MAX WITHDRAWAL CAPPED AT RM88 
                li ONLY FOR EPICWIN AND MEGAH5 GAMES
                li ACCOUNT BALANCE MUST BE BELOW RM1 BEFORE CLAIMING 
                li ONGOING PROMOTION DETECTED, PROCEEDING WITH DEPOSIT WILL COMBINE PROMO TERMS
                li OTHERWISE, DEPOSIT WILL FOLLOW EPIC WORLD CUP PROMOTION T&amp;Cs
            p
              strong GENERAL TERMS AND CONDITIONS
            p
              ul
                li WITHDRAWAL IS LIMITED TO 5 TIMES PER DAY 
                li MINIMUM WITHDRAWAL AMOUNT IS RM10 
                li EPICWIN RESERVES THE RIGHT TO SUSPEND OR TERMINATE ANY ACCOUNT INVOLVED IN ABUSE, FRAUD, OR T&amp;C VIOLATIONS WITHOUT PRIOR NOTICE 
                li MULTIPLE ACCOUNTS, DUPLICATE CLAIMS, OR PROMOTIONAL ABUSE ARE STRICTLY PROHIBITED 
                li ALL REWARDS, TURNOVER REQUIREMENTS, AND WITHDRAWALS ARE SUBJECT TO SYSTEM VERIFICATION BEFORE APPROVAL
          .terms-text.text-uppercase(v-if="getLanguage=='my'")
            p
              strong Terma & Syarat
            p
              strong Token Berdasarkan Jumlah Deposit Harian
            p
              ul
                li Deposit RM80: Dapat 1 Token
                li Deposit RM150: Dapat 3 Token
                li Deposit RM500: Dapat 8 Token
                li Deposit RM1000: Dapat 15 Token
            p
              strong Butiran Ganjaran
            p
              ul
                li Ganjaran tersedia dari RM8 hingga RM88
                li Maksimum 15 token boleh diperoleh setiap hari
                li Maksimum 15 token boleh disimpan dalam wallet 
                li Keperluan turnover x10 sebelum pengeluaran
                li Pengeluaran maksimum dihadkan kepada RM88
                li Hanya untuk game EPICWIN dan MEGAH5
                li Baki akaun mesti di bawah RM1 sebelum membuat tuntutan
                li Promosi sedang berlangsung dikesan, meneruskan deposit akan menggabungkan terma promosi
                li Jika tidak, deposit akan mengikut Terma & Syarat promosi Epic World Cup
            p
              strong Terma & Syarat Umum
            p
              ul
                li Pengeluaran dihadkan kepada 5 kali sehari
                li Jumlah minimum pengeluaran ialah RM10 
                li EpicWin berhak untuk menggantung atau menamatkan akaun ahli sekiranya berlaku penyalahgunaan bonus, penipuan, atau pelanggaran T&C tanpa notis awal
                li Akaun berganda, tuntutan berulang, atau penyalahgunaan promosi adalah dilarang sama sekali
                li Semua ganjaran, turnover, dan pengeluaran tertakluk kepada semakan sistem sebelum diluluskan
          .terms-text(v-if="getLanguage=='zh'")
            p
              strong 条款与条件
            p
              strong 每日累计存款代币奖励
            p
              ul
                li 存款 RM80：获得 1 个代币
                li 存款 RM150：获得 3 个代币 
                li 存款 RM500：获得 8 个代币
                li 存款 RM1000：获得 15 个代币
            p
              strong 奖励详情
            p
              ul
                li 奖励金额范围为 RM8 至 RM88
                li 每日最多可获得 15 个代币 
                li 钱包内最多可储存 15 个代币
                li 提款前需完成 x10 流水要求
                li 最高提款金额为 RM88
                li 只可玩EPICWIN 和 MEGAH5 老虎机游戏 
                li 申领奖励前，账户余额必须低于 RM1
                li 检测到进行中的优惠活动，继续存款将合并优惠条款
                li 否则，存款将遵循 Epic World Cup 活动条款与条件
            p
              strong 一般条款与条件
            p
              ul
                li 每日最多可提款 5 次
                li 最低提款金额为 RM10
                li 如发现任何滥用优惠、欺诈行为或违反条款与条件，EpicWin 有权在不另行通知的情况下暂停或终止会员账户
                li 严禁多账号、重复领取或任何优惠滥用行为 
                li 所有奖励、流水要求及提款均需经过系统审核后方可批准
      // Shoot animation overlay
      #shoot-overlay.overlay(:class="{'active': ballKick == true}")
        img.shoot-anim-img(src='/new/img/events/june-2026/PNG/shoot-action-pop-up.png' alt='SHOOT!')
      // Reward popup overlay
      #reward-overlay.overlay(:class="{'active': showPrize == true}")
        .reward-box
          img#reward-img.reward-main-img(:src="`/new/img/events/june-2026/PNG/POP UP/RM${prizeWon}-POP-UP.png`" alt='Reward')
          .reward-btns
            button#claim-btn.reward-btn(aria-label='Claim reward' @click="goTo")
              img(src='/new/img/events/june-2026/PNG/POP UP/CLAIM-BUTTON.png' alt='Claim')
            button#continue-btn.reward-btn(aria-label='Continue  shooting' @click="resetBall();claimAct()")
              img(src='/new/img/events/june-2026/PNG/POP UP/CONTINUE-SHOOT.png' alt='Continue Shoot')
      // T&C popup overlay
      #tc-overlay.overlay(:class="{'active': showTnc == true}" @click="toggleTnc")
        img.tc-img(src='/new/img/events/june-2026/PNG/POP UP/T-&-C.png' alt='Terms and Conditions')

</template>
<script>
export default{
	data(){
		return{
      startRender: false,
			goDepo:true,
      tokenBalance: 0,
      showPrize:false,
      prizeWon: null,
      toLeft: false,
      toRight: false,
      ballCaught: false,
      ballKick: false,
      diveLeft: false,
      diveRight: false,
      gkStance: 'goalkeeper-A',
      ballDir: "BALL",
      showTnc: false
		}
	},
	computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
	watch:{
    sessionToken(newState, oldState){
      if(newState === '' || newState === undefined){
        this.reset()
      }else{
        this.getSmashToken()
      }
    }
  },
  mounted() {
    // this.addStylesheet();
    window.scroll(0,0)
    document.body.classList.add("custom-padding");
    this.getSmashToken()
  },
  beforeDestroy() {
    this.reset()
    // this.removeStylesheet();
    // document.body.classList.remove("custom-font");
  },
	methods:{
    goTo(){
      this.$router.push("/inbox").catch(error =>{})
    },
    togglePop(){
      this.showPrize = !this.showPrize
    },
    claimAct(){
      this.togglePop()
    },
    getSmashToken(){
      if (this.sessionToken) {
        this.startRender = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getSmashToken", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.tokenBalance = response.data[0].token
              }
              this.startRender = false
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
              this.startRender = false           
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.startRender = false
          });
        
      }
    },
    kickBall(src){
      if (this.sessionToken) {
        this.startRender = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/smashEgg", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.prizeWon = response.data[0].prize_amount
                if(this.prizeWon < 38){
                  this.ballCaught = true
                }else{
                  this.ballCaught = false
                }
                var ball = document.getElementById("ball");
                this.ballKick = true
                ball.style.transition = "";
                setTimeout(() => {
                  this.ballKick = false
                  if(this.ballCaught == false){
                    if(this.toLeft == true){
                      this.gkStance = 'goalkeeper-right-A'
                      this.diveRight = true
                      this.ballDir = "right-ball"
                      ball.classList.add('fly-right');
                    }
                    
                    if(this.toRight == true){
                      this.gkStance = 'goalkeeper-left-A'
                      this.diveLeft = true
                      this.ballDir = "LEFT-BALL"
                      ball.classList.add('fly-left');
                    } 
                    if(this.toLeft == false && this.toRight == false){
                      this.gkStance = 'goalkeeper-center-A'
                      this.ballDir = "CENTER-BALL"
                      ball.classList.add('fly-center');
                    } 
                  }
                  if(this.ballCaught == true){
                    if(this.toLeft == true){
                      this.gkStance = 'goalkeeper-right-B'
                      this.diveRight = true
                      this.ballDir = "right-ball"
                      ball.classList.add('fly-right');
                    }
                    
                    if(this.toRight == true){
                      this.gkStance = 'goalkeeper-left-B'
                      this.diveLeft = true
                      this.ballDir = "LEFT-BALL"
                      ball.classList.add('fly-left');
                    } 
                    if(this.toLeft == false && this.toRight == false){
                      this.gkStance = 'goalkeeper-CENTER-B'
                      this.ballDir = "CENTER-BALL"
                      ball.classList.add('fly-center');
                    } 
                  }
                  
                  setTimeout(() => {
                    this.showPrize = true
                  }, 900) 
                }, 700) 
                this.getSmashToken()
              }
              
            } else {
              this.showPrize = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            this.showPrize = false
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }else{
        this.$router.push("/login").catch(err => {});
      }
    },
    depoAct(){
      if(this.isLoggedIn){
				this.$router.push("/deposit").catch(err => {});
			}else{
				this.$router.push("/login").catch(err => {});
			}
    },
    resetBall(){
      var ball = document.getElementById("ball");
      this.toLeft = false
      this.toRight = false
      this.diveLeft = false
      this.diveRight = false
      this.gkStance = 'goalkeeper-A'
      this.ballDir = "BALL"
      ball.style.transition = "none";
      ball.classList.remove("fly-left", "fly-center", "fly-right", "nudge-left", "nudge-right");
    },
    reset(){
      this.showPrize = false
      this.tokenBalance = 0
    },
    toggleLeft(){
      if(!this.sessionToken){
        this.$router.push("/login").catch(err => {});
      }
      this.toRight = false
      this.toLeft = !this.toLeft
    },
    toggleRight(){
      if(!this.sessionToken){
        this.$router.push("/login").catch(err => {});
      }
      this.toLeft = false
      this.toRight = !this.toRight
    },
    toggleTnc(){
      this.showTnc = !this.showTnc
    }
	}
}
</script>
<style lang="css" scoped>
* {
  margin: 0;
  padding: 0;
}

/* *,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
} */

/* html,
body {
  height: 100%;
  overflow: hidden;
}

body {
  background: #060810;
  display: flex;
  justify-content: center;
  font-family: Arial, sans-serif;
  -webkit-tap-highlight-color: transparent;
} */

/* ─────────────────────────────────────────────
   Outer wrapper — full viewport, centered
───────────────────────────────────────────── */
.con{
  padding-top: 70px;
}

.game-wrap {
  width: 100%;
  width: 380px;
  max-width: 380px;
  height: 100dvh;
  /* height: 100vh; */
  /* overflow: hidden; */
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

/* ─────────────────────────────────────────────
   Game area — fills the wrapper exactly.
   Field image covers it via object-fit.
   All children are absolute overlays.
───────────────────────────────────────────── */
.game-area {
  width: 100%;
  /* height: 80%; */
  height: 695px;
  flex-shrink: 0;
  position: relative;
}

.field-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  z-index: 0;
}

/* Shared base for all layered elements */
.layer {
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.title-bar img {
  width: 82%;
  max-width: 300px;
}

/* ── HUD row (counter + info icon) ── */
.hud-row {
  top: 40%;
  justify-content: space-between;
  padding: 0 5%;
}

.counter {
  display: flex;
  align-items: center;
  width: 30%;
  position: relative;
  /* gap: 15px; */
}

.shoot-left-label {
  height: clamp(25px, 4.5vh, 20px);
}

.digit-img {
  height: clamp(14px, 4.5vh, 18px);
  position: absolute;
  right: 6%;
}

.info-icon {
  height: clamp(20px, 4.5vh, 25px);
  cursor: pointer;
  transition: transform 0.1s ease;
}

.info-icon:active {
  transform: scale(0.88);
}

/* ── T&C subtitle ── */
.tc-bar {
  top: 44%;
  display: flex;
  justify-content: flex-start;
  padding-left: 5%;
}

.tc-bar img {
  width: 90%;
}

/* ── Goalkeeper ── */
.goalkeeper {
  position: absolute;
  width: 40%;
  left: 50%;
  bottom: 23%;
  transform: translateX(-50%);
  transition:
    left 0.8s ease-out,
    width 0.8s ease-out,
    bottom 0.8s ease-out;
  pointer-events: none;
  z-index: 3;
}

.goalkeeper.dive-left {
  left: 31%;
  width: 40%;
  /* bottom: 27%; */
  bottom: 23%;
}

.goalkeeper.dive-right {
  left: 66%;
  width: 40%;
  /* bottom: 27%; */
  bottom: 23%;
}

/* ── Ball row ── */
.ball-row {
  bottom: 12%;
  top: auto;
  gap: 20px;
}

.arrow-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  line-height: 0;
}

.arrow-btn img {
  width: clamp(40px, 12vw, 30px);
  height: clamp(40px, 12vw, 30px);
  display: block;
  transition: transform 0.1s ease;
}

.arrow-btn:active img {
  transform: scale(0.88);
}

.arrow-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.ball {
  width: clamp(40px, 14vw, 35px);
  height: clamp(40px, 14vw, 35px);
  object-fit: contain;
  transform-origin: center center;
  pointer-events: none;
}

.ball.nudge-left {
  transform: translateX(-20px);
  transition: transform 0.15s ease-out;
}

.ball.nudge-right {
  transform: translateX(20px);
  transition: transform 0.15s ease-out;
}

.ball.fly-left {
  transform: translateX(-120px) translateY(-140px) scale(0.38);
  transition: transform 0.75s ease-in;
}
.ball.fly-center {
  transform: translateY(-110px) scale(0.38);
  transition: transform 0.75s ease-in;
}
.ball.fly-right {
  transform: translateX(110px) translateY(-140px) scale(0.38);
  transition: transform 0.75s ease-in;
}

/* ── Shoot button ── */
.shoot-bar {
  bottom: 5%;
  top: auto;
}

.shoot-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  line-height: 0;
  transition: transform 0.1s ease;
}

.shoot-btn img {
  width: 90px;
  display: block;
}

.shoot-btn:active {
  transform: scale(0.94);
}
.shoot-btn:disabled {
  cursor: default;
}
.shoot-btn:disabled img {
  opacity: 0.4;
}

/* ── Terms (bottom strip) ── */
.terms-bar {
  width: 100%;
  /* height: 20%; */
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  padding: 6px 10px 8px;
  background: #023c18;
  /* overflow: hidden; */
}

.terms-text {
  width: 100%;
}

.terms-text p {
  color: #ccc;
  /* font-size: 7.5px; */
  font-size: 10px;
  line-height: 1.5;
}

.terms-text strong {
  color: #fff;
}

/* ─────────────────────────────────────────────
   Overlays
───────────────────────────────────────────── */
.overlay {
  display: none;
  position: fixed;
  inset: 0;
  z-index: 300;
  justify-content: center;
  align-items: center;
}

.overlay.active {
  display: flex;
}

#shoot-overlay {
  background: rgba(0, 0, 0, 0.15);
  pointer-events: none;
}

.shoot-anim-img {
  width: min(290px, 76vw);
  animation: popIn 0.25s ease-out forwards;
}

#reward-overlay {
  background: rgba(0, 0, 0, 0.72);
}

#tc-overlay {
  background: rgba(0, 0, 0, 0.82);
  cursor: pointer;
}

.tc-img {
  width: min(360px, 90vw);
  animation: popIn 0.3s ease-out forwards;
}

.reward-box {
  width: min(360px, 90vw);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  animation: popIn 0.3s ease-out forwards;
}

.reward-main-img {
  width: 80%;
  display: block;
}

.reward-btns {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: -25%;
}

.reward-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  line-height: 0;
  transition: transform 0.1s ease;
}

.reward-btn img {
  width: clamp(120px, 34vw, 145px);
  display: block;
}

#claim-btn {
  height: 40px;
}

#claim-btn img {
  height: 100%;
}

#continue-btn {
  height: 40px;
}

#continue-btn img {
  height: 100%;
}
/* ─────────────────────────────────────────────
   Height breakpoints
───────────────────────────────────────────── */

@media (min-height: 884px) {
  .title-bar {
    top: 5%;
  }

  .hud-row {
    top: 31%;
  }

  .tc-bar {
    top: 35%;
  }

  .goalkeeper {
    /* bottom: 30%; */
    /* bottom: 28%; */
  }

  .goalkeeper.dive-left {
    /* bottom: 33%; */
    /* bottom: 30%; */
  }

  .goalkeeper.dive-right {
    /* bottom: 33%; */
    /* bottom: 30%; */
  }

  .ball {
    width: clamp(50px, 14vw, 35px);
    height: clamp(50px, 14vw, 35px);
  }

  .ball-row {
    /* bottom: 20%; */
  }

  .ball.fly-left {
    transform: translateX(-120px) translateY(-150px) scale(0.38);
  }
  .ball.fly-center {
    transform: translateY(-110px) scale(0.38);
  }
  .ball.fly-right {
    transform: translateX(110px) translateY(-150px) scale(0.38);
  }

  .shoot-bar {
    /* bottom: 13%; */
  }
}

@media (max-height: 884px) {
  .game-area {
    /* height: 80%; */
  }

  .terms-bar {
    /* height: 20%; */
  }

  .title-bar {
    /* top: 8%; */
    top: 6%;
  }

  .hud-row {
    top: 36%;
  }

  .tc-bar {
    top: 40%;
  }

  /* .goalkeeper {
    bottom: 16%;
  } */

  .goalkeeper.dive-left {
    /* bottom: 18%; */
    /* bottom: 22%; */
  }

  .goalkeeper.dive-right {
    /* bottom: 22%; */
  }

  .ball-row {
    /* bottom: 8%; */
    bottom: 15%;
  }

  .ball.fly-left {
    transform: translateX(-100px) translateY(-110px) scale(0.38);
  }
  .ball.fly-center {
    transform: translateY(-110px) scale(0.38);
  }
  .ball.fly-right {
    transform: translateX(100px) translateY(-110px) scale(0.38);
  }

  /* .shoot-bar {
    bottom: 1%;
  } */
}

@media (max-height: 760px) {
  .game-area {
    /* height: 90%; */
  }

  .terms-bar {
    /* height: 10%; */
  }

  .title-bar {
    top: 8%;
  }

  .hud-row {
    top: 36%;
  }

  .tc-bar {
    top: 40%;
  }

  .goalkeeper {
    /* bottom: 16%; */
  }

  .goalkeeper.dive-left {
    /* bottom: 18%; */
  }

  .goalkeeper.dive-right {
    /* bottom: 18%; */
  }

  .ball.fly-left {
    transform: translateX(-100px) translateY(-110px) scale(0.38);
  }
  .ball.fly-center {
    transform: translateY(-110px) scale(0.38);
  }
  .ball.fly-right {
    transform: translateX(100px) translateY(-110px) scale(0.38);
  }

  .shoot-bar {
    /* bottom: 1%; */
  }
}

/* ── Animation ── */
@keyframes popIn {
  from {
    transform: scale(0.55);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

p ul{
  margin-left: 15px;
}

@media (max-width: 767px) {
  .terms-bar{
    padding-bottom: 65px;
  }
}

@media (max-width: 368){
  .con{
    padding-left: 0;
    padding-right: 0;
  }
}
</style>